import { Send, Wrench, Layers, ChevronRight } from 'lucide-react';
import type { BroadcastType } from '../types/broadcast.types';

interface StepSelectTypeProps {
    onSelect: (type: BroadcastType) => void;
}

const types: {
    type: BroadcastType;
    icon: React.ReactNode;
    title: string;
    description: string;
    badge?: string;
    badgeColor?: string;
}[] = [
    {
        type: 'standard',
        icon: <Send className="w-6 h-6" />,
        title: 'Normal',
        description: 'Mensagem padrão (com escolha de Tags)',
    },
    {
        type: 'utility',
        icon: <Wrench className="w-6 h-6" />,
        title: 'Utility Template',
        description: 'Template aprovado pelo Meta',
        badge: 'Fora da janela 24h',
        badgeColor: 'bg-emerald-100 text-emerald-700',
    },
    {
        type: 'esteira',
        icon: <Layers className="w-6 h-6" />,
        title: 'Esteira',
        description: 'Pack de páginas + templates já validado',
        badge: 'Fora da janela 24h',
        badgeColor: 'bg-emerald-100 text-emerald-700',
    },
];

export default function StepSelectType({ onSelect }: StepSelectTypeProps) {
    return (
        <div className="flex flex-col items-center justify-center h-full py-8">
            <div className="text-center mb-10">
                <h3 className="text-2xl font-bold text-gray-900">Tipo de Envio</h3>
                <p className="text-gray-500 mt-2 text-sm">Escolha como você quer enviar o broadcast</p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 w-full max-w-2xl">
                {types.map(({ type, icon, title, description, badge, badgeColor }) => (
                    <button
                        key={type}
                        type="button"
                        onClick={() => onSelect(type)}
                        className="group relative flex flex-col gap-4 p-6 border-2 border-gray-200 rounded-2xl bg-white text-left
                                   hover:border-[#7dd3fc] hover:shadow-lg hover:-translate-y-0.5 transition-all duration-200 cursor-pointer"
                    >
                        {/* Icon */}
                        <div className="w-12 h-12 rounded-xl bg-gray-100 group-hover:bg-[#7dd3fc]/10 flex items-center justify-center text-gray-500 group-hover:text-[#38bdf8] transition-colors">
                            {icon}
                        </div>

                        {/* Text */}
                        <div>
                            <div className="flex items-center gap-2 mb-1">
                                <h4 className="font-semibold text-gray-900 text-base">{title}</h4>
                            </div>
                            <p className="text-sm text-gray-500">{description}</p>
                            {badge && (
                                <span className={`inline-block mt-2 text-xs font-medium px-2 py-0.5 rounded-full ${badgeColor}`}>
                                    {badge}
                                </span>
                            )}
                        </div>

                        {/* Arrow */}
                        <ChevronRight className="absolute right-4 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-300 group-hover:text-[#38bdf8] transition-colors" />
                    </button>
                ))}
            </div>
        </div>
    );
}
